import { AccountMergeRequestSearchViewModel } from './AccountMergeRequestSearchViewModel'
import { computed, makeObservable } from 'mobx'
import { MergeAccountsDialogViewModel } from './MergeAccountsDialog/MergeAccountsDialogViewModel'
import { RejectMergeDialogViewModel } from './RejectMergeDialog/RejectMergeDialogViewModel'
import { AccountMergeRequestStore } from './AccountMergeRequestStore'
import { AlertFactory } from '../../alerts/Alert'
import once from 'lodash/once'
import { IgnoreMergeRequestDialogViewModel } from './IgnoreMergeRequestDialog/IgnoreMergeRequestDialogViewModel'

export class AccountMergeRequestsViewModel {
  /**
   * Searcher for merge requests.
   */
  searchViewModel = new AccountMergeRequestSearchViewModel(this._store)

  /**
   * View Model for the "Merge Accounts" dialog.
   */
  mergeAccountsDialogVM = new MergeAccountsDialogViewModel(
    this._store,
    this.searchViewModel.refreshItems,
    this._newAlert,
  )

  /**
   * View Model for the "Reject Merge Request" dialog.
   */
  rejectMergeDialogVM = new RejectMergeDialogViewModel(
    this._store,
    this.searchViewModel.refreshItems,
    this._newAlert,
  )

  /**
   * View Model for the "Ignore Merge Request" dialog.
   */
  ignoreMergeRequestVM = new IgnoreMergeRequestDialogViewModel(
    this._store,
    this.searchViewModel.refreshItems,
    this._newAlert,
  )

  /**
   * Ensure we only activate the searcher once, as we want to keep it around
   * for subsequent page views of scope change requests.
   */
  private activateSearcher = once(() => this.searchViewModel.activate())

  constructor(
    private readonly _store: AccountMergeRequestStore,
    private readonly _newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  /**
   * The total number of merge requests.
   */
  @computed
  get total() {
    return this.searchViewModel.mergeRequests.length
  }

  /**
   * Indicates that a modal is showing.
   */
  @computed
  get modalsShowing() {
    return (
      this.rejectMergeDialogVM.showing || this.mergeAccountsDialogVM.showing
    )
  }

  /**
   * Activates the view model.
   */
  activate() {
    this.activateSearcher()
  }
}
